import {BaseComponentLoader} from './BaseComponentLoader';

/**
 * Dynamically load JS components
 */
export class ComponentLoader extends BaseComponentLoader {
    /**
     * Dynamically import component
     * Note: Import path must be hardcoded for now, doesn't work with a variable
     *
     * @param {String} name
     * @return {Promise}
     */
    importComponent(name) {
        return import(`./../../../../components/${name}.js`);
    }
}
